import { apiClient } from './client'
import type { RequestProcurementCompletion } from './types'

export async function getRequestProcurementCompletion(
  requestId: string,
): Promise<RequestProcurementCompletion> {
  const res = await apiClient.get<{ success: true; data: RequestProcurementCompletion }>(
    `/requests/${requestId}/procurement-completion`,
  )
  return res.data.data
}

export async function recalculateRequestProcurementCompletion(
  requestId: string,
): Promise<{ requestId: string; recalculated: number }> {
  const res = await apiClient.post<{
    success: true
    data: { requestId: string; recalculated: number }
  }>(`/requests/${requestId}/procurement-completion/recalculate`)
  return res.data.data
}
